export default __webpack_public_path__ + "static/media/drawing-man10-focusfill.157865a3.svg";